<template>
  <section class="legal" id="legales" >
      <h2>LEGALES</h2>
      <div>
        <CardFactors
          v-for="(item, index) in legalTexts"
          :key="index"
          :title="item.subtitle"
          :src="item.imgPath"
          customClass="cardFactors--align-start"     
        />
      </div>
  </section>
</template>
<script>
import CardFactors from "@/components/atoms/CardFactors.vue";
import newTexts from "@/data/newTexts"

export default {
  name: "Legales",
  components: {
    CardFactors,
  },
  data(){
    return {
      legalTexts: newTexts.legalSection
    }
  },
};
</script>
